import { render } from "./Dumping_ground.vue?vue&type=template&id=0a895cfa&scoped=true"
import script from "./Dumping_ground.vue?vue&type=script&lang=js"
export * from "./Dumping_ground.vue?vue&type=script&lang=js"

import "./Dumping_ground.vue?vue&type=style&index=0&id=0a895cfa&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a895cfa"]])

export default __exports__